export default function EndCallIcon({ width = 32, height = 32 }: { width?: number; height?: number }) {
  return (
    <svg width={width} height={height} viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 8.88889C0 3.97969 3.97969 0 8.88889 0H23.1111C28.0203 0 32 3.97969 32 8.88889V23.1111C32 28.0203 28.0203 32 23.1111 32H8.88889C3.97969 32 0 28.0203 0 23.1111V8.88889Z'
        fill='#FFF2F2'
      />
      <g clip-path='url(#clip0_20445_45483)'>
        <path
          d='M15.1183 16.8721C15.7949 17.5493 16.5595 18.1323 17.3917 18.6054L18.2383 17.7588C18.4196 17.5795 18.6484 17.456 18.8977 17.4028C19.1471 17.3497 19.4064 17.3691 19.645 17.4588C20.2498 17.6845 20.8783 17.841 21.5183 17.9254C21.8387 17.9707 22.1317 18.1309 22.3426 18.3763C22.5536 18.6216 22.6682 18.9352 22.665 19.2588V21.2588C22.6657 21.4444 22.6277 21.6282 22.5533 21.7983C22.479 21.9684 22.3699 22.1212 22.233 22.2467C22.0962 22.3722 21.9347 22.4678 21.7588 22.5272C21.5829 22.5867 21.3966 22.6088 21.2117 22.5921C19.1602 22.3692 17.1897 21.6682 15.4583 20.5454C14.6552 20.0355 13.9107 19.4385 13.2383 18.7654M11.4583 16.5388C10.3356 14.8074 9.63457 12.8369 9.41166 10.7854C9.395 10.6011 9.41691 10.4153 9.47599 10.2398C9.53508 10.0644 9.63004 9.90322 9.75484 9.76651C9.87964 9.6298 10.0315 9.52057 10.2009 9.44578C10.3702 9.37099 10.5532 9.33227 10.7383 9.3321H12.7383C13.0619 9.32891 13.3755 9.44348 13.6208 9.65445C13.8661 9.86542 14.0264 10.1584 14.0717 10.4788C14.1561 11.1188 14.3126 11.7472 14.5383 12.3521C14.628 12.5907 14.6474 12.85 14.5943 13.0993C14.5411 13.3487 14.4176 13.5775 14.2383 13.7588L13.3917 14.6054'
          stroke='#DA0808'
          stroke-width='1.33333'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
        <path
          d='M22.6693 9.33203L9.33594 22.6654'
          stroke='#DA0808'
          stroke-width='1.33333'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_20445_45483'>
          <rect width='16' height='16' fill='white' transform='translate(8 8)' />
        </clipPath>
      </defs>
    </svg>
  );
}
